import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Label } from 'semantic-ui-react';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';
import { GroupByContainer } from './styles';

interface IGroupByTagProps {
    isDrillDownActive: boolean;
    isTagFilterApplied: boolean;
    setIsTagFilterApplied: Function;
}

function GroupByTag(props: IGroupByTagProps) {
    const { isTagFilterApplied, setIsTagFilterApplied, isDrillDownActive } = props;
    return (
        <GroupByContainer>
            <Form formName="filterReport">
                <UniversalInput
                    label={{
                        text: (
                            <Label>
                                <FormattedMessage id="reports.label.groupByTag" />
                            </Label>
                        ),
                    }}
                    inputData={{
                        isInputRequired: false,
                        type: INPUT_TYPES.SWITCH_CHECKBOX,
                        name: 'groupByTag',
                        classes: [''],
                        checked: isTagFilterApplied,
                        disabled: isDrillDownActive,
                        tooltipText: '',
                        value: isTagFilterApplied,
                        currentData: {},
                        fields: [],
                    }}
                    inputActions={{
                        onFieldChange: e => {
                            setIsTagFilterApplied(e.groupByTag);
                            console.log({ e, isTagFilterApplied });
                        },
                    }}
                />
            </Form>
        </GroupByContainer>
    );
}

export default GroupByTag;
